import type { GlobalTranslations } from "../interfaces/global";

export const globalTranslations: GlobalTranslations = {
  two_factor_required_generic: "Ative a autenticação em duas etapas para continuar",
  two_factor_required_modal_title: "Autenticação em duas etapas necessária",
  two_factor_required_modal_cancel: "Cancelar",
  two_factor_required_modal_go_to_settings: "Ir para configurações",
  two_factor_challenge_title: "Verifique sua identidade",
  two_factor_challenge_description:
    "Digite o código de 6 dígitos do seu aplicativo autenticador para continuar.",
  two_factor_challenge_submit: "Verificar",
  two_factor_challenge_error_invalid_code: "Código incorreto. Tente novamente.",
  input_error_invalid_email: "Insira um e-mail válido.",
  input_error_required: "Este campo é obrigatório",
  input_error_min_length: "Este campo deve ter pelo menos {{length}} caracteres",
  input_error_max_length: "Este campo deve ter no máximo {{length}} caracteres",
  input_error_min_items: "Deve ter pelo menos {{items}} itens",
  input_error_max_items: "Deve ter no máximo {{items}} itens",
  input_error_min_value: "Deve ser maior ou igual a {{min}}",
  input_error_max_value: "Deve ser menor ou igual a {{max}}",
  input_error_too_small: "O valor mínimo é {{min}}",
  input_error_too_big: "O valor máximo é {{max}}",
  input_error_invalid_url: "Insira uma URL válida",
  input_error_invalid_uuid: "Identificador inválido",
  input_error_invalid_format: "O formato não é válido",
  input_error_invalid_value: "O valor não é válido",
  logout: "Sair",
  input_error_phone_indicative_required: "O indicativo é obrigatório",
  input_error_phone_required: "O número de telefone é obrigatório",
  input_error_register_code: "O formato deve ser xxxxxxxxxxxxxx== onde x são letras, números e símbolos.",
  input_error_phone_invalid: "O número de telefone não tem um formato válido para o país selecionado",
  input_error_not_terms: "Você deve aceitar nossos termos e condições",
  error_login_credentials: "Verifique seu usuário ou senha.",
  successful_deletion_message: "Foi excluído com sucesso.",
  successful_disabled_message: "Foi desativado com sucesso.",
  successful_active_message: "Foi ativado com sucesso.",
  successful_create_message: "Foi criado com sucesso.",
  successful_update_message: "Atualizado com sucesso.",
  error_token_message:
    "Ocorreu um erro devido à inexistência ou uso prévio do token. Por favor, gere um novo token para continuar.",
  input_optional_label: "(opcional)",
  input_show_password_label: "Mostrar senha",
  input_hide_password_label: "Ocultar senha",
  input_search_placeholder: "Procurar",
  input_phone_number_placeholder: "Insira seu número de telefone",
  input_phone_number_label: "Número de telefone",
  not_found_message: "Nenhum resultado encontrado",
  input_phone_label: "Telefone",
  input_phone_placeholder: "Insira o número de telefone",
  input_date_placeholder: "Selecione uma data",
  sidebar_settings_label: "Configurações",
  sidebar_section_billeteras: "Carteiras",
  sidebar_section_operaciones: "Operações",
  sidebar_section_analitica: "Análise",
  sidebar_section_gestion: "Gestão",
  sidebar_section_tarjetas: "Cartões",
  sidebar_menu_wallets_home: "Carteiras",
  sidebar_menu_wallets: "Carteiras",
  sidebar_menu_payouts: "Enviar dinheiro",
  sidebar_menu_breb_qr_pay: "Pagar com QR",
  sidebar_menu_payout_batches: "Pagamentos em lote",
  sidebar_menu_holders: "Titulares",
  sidebar_menu_pockets: "Compartimentos",
  sidebar_menu_confirmations: "Confirmações",
  sidebar_menu_payments: "Solicitações de pagamento",
  sidebar_menu_payout_rescue: "Resgate de dispersões",
  sidebar_menu_swaps: "Swaps",
  sidebar_menu_audit: "Auditoria",
  sidebar_menu_accounts_tracking: "Acompanhamento de contas",
  sidebar_menu_payins: "Receber dinheiro",
  sidebar_menu_payments_activity: "Atividade",
  sidebar_menu_payments_notifications: "Notificações",
  sidebar_menu_crypto_swaps_group: "Cripto",
  sidebar_menu_crypto_swaps: "Comprar USDT",
  sidebar_menu_crypto_sell: "Vender USDT",
  sidebar_menu_crypto_swaps_history: "Histórico",
  sidebar_menu_payments_ledger: "Livro contábil",
  sidebar_menu_account_verification: "Verificação de contas",
  sidebar_menu_cardholder_onboarding: "Cadastro de titulares",
  sidebar_menu_cards: "Cartões",
  sidebar_menu_cards_notifications: "Notificações",
  sidebar_menu_routes_countries: "Rotas e países",
  sidebar_menu_organizations: "Organizações",
  sidebar_menu_wallet_top_ups: "Recargas de carteiras",
  sidebar_menu_wallet_debits: "Débitos em carteiras",
  sidebar_menu_card_wallets: "Carteira de cartões",
  sidebar_menu_internal_api_keys: "Chaves internas",
  sidebar_menu_payment_rails: "Trilhos de pagamento",
  sidebar_menu_payment_limits: "Limites de valor",
  sidebar_menu_rate_providers: "Provedores de taxas",
  sidebar_menu_metrics: "Métricas",
  sidebar_menu_payment_routes: "Corredores e provedores",
  sidebar_menu_payment_fees: "Tarifas e comissões",
  sidebar_menu_payment_taxes: "Impostos",

  sidebar_menu_deposit_clabes: "CLABEs de depósito",
  sidebar_menu_deposit_cvus: "CVUs de depósito",
  sidebar_menu_quoter: "Cotador",
  sidebar_menu_quoter_coloca: "Cotador Coloca",
  sidebar_menu_news: "Novidades",
  no_access_title: "Você não tem permissão",
  no_access_description:
    "Você não tem permissão para acessar esta seção. Se acha que deveria, fale com o administrador da sua conta.",
  no_access_back_home: "Voltar ao início",
  no_navigation_access_title: "Sua conta ainda não tem acessos",
  no_navigation_access_description:
    "Nenhum acesso foi atribuído a você ainda. Fale com o administrador da sua organização para liberar o que você precisa.",
  sidebar_menu_users: "Usuários",
  sidebar_menu_clients: "Clientes",
  sidebar_menu_api_keys: "Chaves de API",
  sidebar_menu_roles: "Perfis",
  sidebar_menu_policies: "Políticas",
  loading_button: "Carregando...",
  pagination_records: "Registros de {{from}} a {{to}} de {{total}}",
  pagination_empty: "Sem registros",
  pagination_total_pages: "Total de páginas ({{lastPage}})",
  pagination_first_page: "Primeira página",
  pagination_prev_page: "Página anterior",
  pagination_next_page: "Página seguinte",
  pagination_last_page: "Última página",
  modal_confirm_button: "Confirmar",
  modal_cancel_button: "Cancelar",
  phone_field_select_country_placeholder: "Selecione um país primeiro",
  phone_field_search_country_placeholder: "Pesquisar país…",
  nav_user_account: "Conta",
  nav_user_settings: "Configurações",
  nav_user_logout: "Sair",
  nav_user_organization: "Organização",
  nav_user_install_app: "Instalar app",
  pwa_update_activated_elsewhere:
    "Há uma nova versão do Coloca. Recarregue esta aba quando terminar o que está fazendo.",
  pwa_reload_action: "Recarregar",
  pwa_update_menu: "Atualizar para a nova versão",
  pwa_install_title: "Instale o Coloca",
  pwa_install_body: "Tenha-o na tela de início e abra sem procurar o link.",
  pwa_install_body_open_in_safari: "Para instalá-lo, abra esta página no Safari.",
  pwa_install_ios_step_share: "Toque em <b>Compartilhar</b>",
  pwa_install_ios_step_share_hint: "Se não estiver na barra, procure em •••",
  pwa_install_ios_step_add: "Escolha <b>Adicionar à Tela de Início</b> e depois <b>Adicionar</b>",
  pwa_install_action: "Instalar",
  pwa_install_later: "Agora não",
  pwa_install_close: "Fechar",
  pwa_install_copy_link: "Copiar link",
  pwa_install_link_copied: "Link copiado. Cole-o no Safari.",
  pwa_install_link_copied_short: "Copiado",
  pwa_install_copy_error: "Não foi possível copiar o link.",
  header_notifications_title: "Notificações",
  header_notifications_empty: "Sem notificações",
  header_notifications_load_more: "Ver anteriores",
  header_notifications_mark_read_failed: "Não foi possível marcar como lida. Tente novamente.",
  pix_key_ph_cpf: "000.000.000-00",
  pix_key_helper_cpf: "11 dígitos, sem pontos nem traços.",
  pix_key_err_cpf: "O CPF deve ter 11 dígitos.",
  pix_key_ph_cnpj: "00.000.000/0000-00",
  pix_key_helper_cnpj: "14 dígitos, sem pontos nem traços.",
  pix_key_err_cnpj: "O CNPJ deve ter 14 dígitos.",
  pix_key_ph_email: "nome@dominio.com",
  pix_key_helper_email: "E-mail em minúsculas, ex.: nome@dominio.com.",
  pix_key_err_email: "Informe um e-mail válido em minúsculas.",
  pix_key_ph_phone: "(11) 98765-4321",
  pix_key_helper_phone: "Número com DDD, até 11 dígitos.",
  pix_key_err_phone: "O telefone deve ter 10 ou 11 dígitos.",
  pix_key_ph_evp: "123e4567-e89b-12d3-a456-426614174000",
  pix_key_helper_evp: "Cole a chave aleatória (formato UUID).",
  pix_key_err_evp: "A chave deve estar no formato UUID.",
  route_error_title: "Ocorreu um erro inesperado",
  route_error_description:
    "Não foi possível exibir esta tela. Recarregue a página para continuar de onde estava.",
  route_error_reload: "Recarregar a página",
  country_ARG: "Argentina",
  country_BRA: "Brasil",
  country_CHL: "Chile",
  country_COL: "Colômbia",
  country_MEX: "México",
  country_PER: "Peru",
  subdivision_placeholder: "Busque um estado ou província",
  subdivision_empty: "Sem resultados",
  amount_hidden: "Valor oculto",
  security_pin_step_label: "Passo {{step}} de {{total}}",
  security_pin_step_create_title: "Escolha seu PIN de 6 dígitos",
  security_pin_step_create_hint: "Evite datas, dígitos repetidos ou em sequência.",
  security_pin_step_confirm_title: "Digite-o novamente",
  security_pin_step_confirm_hint: "Para garantir que você se lembra dele.",
  security_pin_step_password_title: "Confirme que é você",
  security_pin_step_password_hint:
    "Digite a senha que você usa para entrar, para que ninguém crie um PIN com a sua sessão aberta.",
  security_pin_password_label: "Senha",
  security_pin_password_show: "Mostrar senha",
  security_pin_password_hide: "Ocultar senha",
  security_pin_password_required: "Digite sua senha.",
  security_pin_show: "Mostrar PIN",
  security_pin_hide: "Ocultar PIN",
  security_pin_issue_repeated: "Não use o mesmo dígito seis vezes.",
  security_pin_issue_sequence: "Evite sequências como 123456 ou 654321.",
  security_pin_issue_pattern:
    "Evite padrões fáceis de adivinhar, como 121212, 112233, 123321 ou linhas do teclado.",
  security_pin_issue_common: "Esse PIN é muito comum. Escolha outro.",
  security_pin_strength_ok: "Bom PIN",
  security_pin_mismatch: "Não corresponde ao PIN que você escolheu. Digite-o novamente.",
  security_pin_next: "Continuar",
  security_pin_back: "Voltar",
  security_pin_submit_create: "Criar PIN",
  security_pin_submit_create_continue: "Criar PIN e continuar",
  security_pin_submit_change: "Salvar novo PIN",
  security_pin_done_title: "Seu PIN está pronto",
  security_pin_done_body: "Vamos pedi-lo em ações sensíveis, como criar cartões ou movimentar dinheiro.",
  security_pin_done_email_backup:
    "Backup por e-mail ativado: se você esquecer o seu PIN, enviamos um código para o seu e-mail.",
  security_pin_done_body_continue: "Agora confirme a ação com seu novo PIN.",
  security_pin_done_body_challenge: "Volte e digite seu novo PIN para confirmar.",
  security_pin_done_continue: "Continuar",
  security_pin_done_close: "Pronto",
  security_pin_done_back_to_challenge: "Digitar meu PIN",
  security_pin_error_password: "A senha não está correta.",
  security_pin_error_generic: "Não conseguimos salvar seu PIN. Tente novamente.",
  security_pin_dialog_create_title: "Crie seu PIN de segurança",
  security_pin_dialog_change_title: "Alterar PIN de segurança",
  security_pin_dialog_reset_title: "Crie um novo PIN",
  security_pin_dialog_description: "Seis dígitos que vão confirmar suas ações sensíveis.",
  step_up_required_title: "Proteja esta ação",
  step_up_choice_totp_name: "App autenticador",
  step_up_choice_totp_badge: "Recomendado · Mais seguro",
  step_up_choice_totp_body:
    "Google Authenticator, Authy ou similar gera um código novo a cada 30 segundos. Mesmo quem souber sua senha não consegue confirmar nada sem o seu celular.",
  step_up_choice_totp_time: "≈ 3 min, em Configurações",
  step_up_choice_pin_name: "PIN de segurança",
  step_up_choice_pin_badge: "Mais rápido",
  step_up_choice_pin_body:
    "Seis dígitos que você escolhe. Você o cria aqui mesmo e continua o que estava fazendo. É menos seguro que o app: é algo que você sabe, não algo que você tem.",
  step_up_choice_pin_time: "≈ 1 min, aqui mesmo",
  step_up_choice_footnote:
    "Você pode começar com o PIN e mudar para o app quando quiser: ao ativá-lo, ele substitui o PIN.",
  step_up_choice_go_totp: "Configurar o app",
  step_up_choice_create_pin: "Criar PIN",
  step_up_meter_security: "Segurança",
  step_up_meter_speed: "Rapidez",
  two_factor_challenge_pin_title: "Digite seu PIN de segurança",
  two_factor_challenge_pin_description: "Os 6 dígitos que você escolheu para confirmar ações sensíveis.",
  two_factor_challenge_pin_forgot: "Esqueceu seu PIN? Crie um novo",
  two_factor_challenge_pin_locked_title: "Seu PIN está bloqueado",
  two_factor_challenge_pin_locked:
    "Houve muitas tentativas erradas. Você poderá tentar de novo em {{time}}, ou criar um novo PIN agora com sua senha.",
  two_factor_challenge_pin_reset_required:
    "Ele foi bloqueado após muitas tentativas erradas. Crie um novo PIN com sua senha para continuar.",
  two_factor_challenge_pin_new: "Criar novo PIN",
  reauth_password_incorrect_hint:
    "A senha não está correta. Após 5 tentativas erradas bloqueamos sua conta por 30 minutos.",
  security_pin_error_reused: "O novo PIN deve ser diferente do atual.",
  security_pin_issue_date:
    "Parece uma data, como um aniversário: uma das primeiras coisas que alguém tentaria.",
  security_pin_issue_phone: "Faz parte do seu número de celular. Escolha outro.",
  two_factor_challenge_totp_locked_title: "Verificação em pausa",
  two_factor_challenge_totp_locked:
    "Houve 5 códigos incorretos seguidos. Você poderá tentar novamente em {{time}}.",
  step_up_sessions_revoked:
    "Por segurança bloqueamos seu PIN e encerramos suas sessões. Entre e crie um novo PIN em Configurações → Segurança.",
  step_up_email_offer_pin: "Não está com o seu PIN à mão?",
  step_up_email_offer_totp: "Não está com o seu celular à mão?",
  step_up_email_offer_action: "Receber um código por e-mail",
  step_up_email_sending: "Enviando o código…",
  step_up_email_title: "Confira o seu e-mail",
  step_up_email_description_fallback:
    "Enviamos um código de 6 dígitos para o seu e-mail. Ele expira em 10 minutos e só vale para esta ação.",
  step_up_email_code_label: "Código que enviamos por e-mail",
  step_up_email_spam_hint: "Não chegou? Confira a pasta de spam ou peça outro código.",
  step_up_email_resend: "Reenviar código",
  step_up_email_resend_in: "Reenviar em {{time}}",
  step_up_email_resent: "Enviamos um código novo. O anterior não serve mais.",
  step_up_email_back_pin: "Voltar ao meu PIN",
  step_up_email_back_totp: "Voltar ao meu app",
  step_up_email_code_invalid:
    "Este código não serve mais: venceu, já foi usado ou teve tentativas demais. Peça um novo.",
  step_up_email_not_enabled:
    "O backup por e-mail está desativado. Você pode ativá-lo em Configurações → Segurança.",
  step_up_email_error_generic: "Não conseguimos enviar o código. Tente novamente em instantes.",
  step_up_choice_pin_email_note: "Inclui backup por e-mail",
  step_up_choice_totp_email_note: "Backup por e-mail opcional",
  step_up_email_backup_error_requires_method:
    "Escolha primeiro o app autenticador ou um PIN: o backup por e-mail é o plano B desse método.",
  step_up_email_backup_error_not_available: "O backup por e-mail não está disponível para a sua conta.",
  step_up_email_backup_error_generic: "Não conseguimos salvar a alteração. Tente novamente.",
  tax_transaction_cost: "Custo de transação",
};
